import { dispatch, req } from "hf-rt";
import { HOST_URL } from "../constants";

const initialState = {
  getCountriesList: false,
  getMenuCountriesList: false,
  countries: [],
  menuCountries: [],
  region: [],
  countryCode: "",
  dutyTax: {
    minHandleChargeCurrency: "HK$"
  },
  activeCountry: "HK"
};

export default {
  name: "countryList",
  actions: {
    updateCountryList: payload =>
      dispatch({ type: "UPDATE_COUNTRY_LIST", payload }),

    updateMenuCountryList: payload =>
      dispatch({ type: "UPDATE_MENU_COUNTRY_LIST", payload }),

    updateDutyTax: payload => dispatch({ type: "UPDATE_DUTY_TAX", payload }),

    saveCountryCode: payload =>
      dispatch({ type: "SAVE_COUNTRY_CODE", payload }),

    updateCountryIncludeHK: payload =>
      dispatch({ type: "UPDATE_COUNTRY_INCLUDE_HK", payload }),

    fetchCountryList: async function () {
      await dispatch({ type: "FETCH_COUNTRYLIST" });
      const response = await fetch(
        `${HOST_URL}/shopping/v1/dutytax/countries/info`,
        {
          credentials: "include",
          method: "GET",
          headers: {
            "content-type": "application/json"
          }
        }
      );
      if (response.ok) {
        const data = await response.json();
        this.updateCountryList(data);
      } else {
        window.logApiErrors(
          "r",
          "fetchCountryList",
          response.status,
          response.statusText
        );
      }
    },
    fetchMenuCountryList: async function () {
      await dispatch({ type: "FETCH_MENU_COUNTRYLIST" });
      const response = await fetch(
        `${HOST_URL}/shopping/v1/static/regions/info`,
        {
          credentials: "include",
          method: "GET",
          headers: {
            "content-type": "application/json"
          }
        }
      );
      if (response.ok) {
        const data = await response.json();
        this.updateMenuCountryList(data);
      } else {
        window.logApiErrors(
          "r",
          "fetchMenuCountryList",
          response.status,
          response.statusText
        );
      }
    },
    fetchCountryIncludeHK: async function () {
      await dispatch({ type: "FETCH_COUNTRY_INCLUDE_HK" });
      const response = await fetch(
        `${HOST_URL}/shopping/v1/deliveries/regions/info`,
        {
          credentials: "include",
          method: "GET",
          headers: {
            "content-type": "application/json"
          }
        }
      );
      if (response.ok) {
        const data = await response.json();
        this.updateCountryIncludeHK(data);
      } else {
        window.logApiErrors(
          "r",
          "fetchCountryIncludeHK",
          response.status,
          response.statusText
        );
      }
    },
    fetchDutyTax: async function (countryCode) {
      await dispatch({ type: "FETCH_DUTY_TAX" });
      if (countryCode !== "CN") {
        const response = await fetch(
          `${HOST_URL}/shopping/v1/dutytax/info/${countryCode}`,
          {
            credentials: "include",
            method: "GET",
            headers: {
              "content-type": "application/json"
            }
          }
        );
        if (response.ok) {
          const data = await response.json();
          this.updateDutyTax(data);
        } else {
          window.logApiErrors(
            "r",
            "fetchDutyTax",
            response.status,
            response.statusText
          );
        }
      }
      await this.saveCountryCode(countryCode);
    }
  },
  reducers: function (state = initialState, action) {
    switch (action.type) {
      case "UPDATE_COUNTRY_LIST":
        return { ...state, countries: action.payload, getCountriesList: true };
      case "UPDATE_MENU_COUNTRY_LIST":
        return {
          ...state,
          menuCountries: action.payload,
          getMenuCountriesList: true
        };
      case "UPDATE_DUTY_TAX":
        return { ...state, dutyTax: action.payload };
      case "SAVE_COUNTRY_CODE":
        return {
          ...state,
          countryCode: action.payload,
          activeCountry: action.payload
        };
      case "UPDATE_COUNTRY_INCLUDE_HK":
        return { ...state, region: action.payload };
      default:
        return state;
    }
  }
};
